import React from 'react';
import { useLocation } from 'react-router-dom';
import useTranslation from '../../../hooks/translation/useTranslation';

function LinksChain() {
  const { pathname } = useLocation();
  const location = pathname.split('/').slice(2);

  if (location.length === 0 || location[0] === '') {
    return null;
  }

  return (
    <div
      className="flex py-[48px] items-center gap-6"
      style={{
        marginTop: (
          !pathname.includes('profile')
            && !pathname.includes('schedule')
            && !pathname.includes('info-content')
            && !pathname.includes('booking')) ? 120 : 68,
      }}
    >
      {(!pathname.includes('profile')
          && !pathname.includes('booking')
          && !pathname.includes('payment-status')
          && !pathname.includes('schedule'))
          && !pathname.includes('info-content')
          && !pathname.includes('password-recovery')
          && (
          <>
            <div className="flex items-center gap-2">
              {location.map(
                (link, index) => (
                  <Title
                    index={index}
                    linkName={link}
                    location={location}
                    key={link}
                  />
                ),
              )}
            </div>
            <div className="grow  h-[2px] bg-white" />
          </>
          )}
    </div>
  );
}

const returnLinkTitle = (title) => {
  const { trans } = useTranslation();
  switch (title) {
    case 'search':
      return trans('search_page');
    case 'profile':
      return trans('profile');
    case 'saved-passengers':
      return trans('chosen_passengers');
    case 'purchased-tickets':
      return trans('purchased_tickets');
    case 'chosen-passengers':
      return trans('chosen_passengers');
    default:
      return 'not Found';
  }
};

function Title({ linkName, index, location }) {
  return (
    <>
      <p className="m-0">
        {returnLinkTitle(linkName)}
      </p>
      {index + 1 < location.length && <div className="arrow right" /> }
    </>
  );
}

export default LinksChain;
